'use strict'

import React from 'react';

import Area from '../components/Area2.jsx';
import Field from '../components/Field3.jsx';
import Layout from '../Layout.jsx';
import SSOConfiguration from './SSOConfiguration.jsx';
import BusinessCaseSettings from './BusinessCaseSettings.jsx';
import LifecycleManagement from './LifecycleManagement.jsx';
import currencies from '../../app/utils/currencies.js';

import sendCommand from '../../app/utils/sendCommand.js';

let request=require('superagent');

class Person extends React.Component {
  render() {
    return (
      <div>
        {this.props.name}, {this.props.email}{this.props.emailConfirmed ? "" :<span> (<i style={{color: "red"}}>not confirmed</i>)</span>}
      </div>
    );
  }
}

class AccessControl extends React.Component {
  submit(event) {
    event.preventDefault();
    //Remove html content <p></p> or <ul></ul>
    let value=event.target.access.value.replace(/<.?(p|ul|br).?>/g,"");
    let domains=value.split("\n")
      .map(item=>item.trim())
      .filter(item=>item.length>0);
    this.props.onChange(domains)
  }

  render() {
    return (
      <div style={{maxWidth:800, paddingBottom:40, paddingTop:30}}>
        <form onSubmit={this.submit.bind(this)}>
          <div style={{paddingBottom:20}}>
            <b>{this.props.property.name}</b> - Access accessControl
          </div>
          <div>
            <Field
              name="access"
              height={3}
              title="Access allowed"
              description="List the email domains that should have access, one domain name per line"
              help="Only listed email-domains are given access"
              value={this.props.property.accessControl!==undefined ? this.props.property.accessControl.join("\n") : ""}
            />
          </div>
          <div>
            <input type="submit" className="save" value="Restrict access"/>
            <a href="#" onClick={this.props.onCancel}>Cancel</a>
          </div>
        </form>
      </div>
    );
  }
}

class ShowProperty extends React.Component {
  constructor(props) {
    super(props);
    this.state={edit:false};
  }

  editProperty(event) {
    event.preventDefault();
    this.setState({edit:!this.state.edit});
  }

  editAccessControl(event) {
    event.preventDefault();
    this.setState({editAccessControl:!this.state.editAccessControl})
  }

  setAccessControl(domains) {
    sendCommand({
      type:"setAccessControl",
      property:this.props.propertyName,
      item: this.props.property.id,
      access: domains
    })
      .then(()=>window.location.reload())
      .catch(error=>{
        console.log("[ERROR] Not able to limit access, got "+error);
        alert("An error occured, please try again");
      })
    ;
  }

  render() {
    var property=this.props.property;
    var countProject=this.props.count!==undefined ? this.props.count(this.props.property) : 0;
    var countProgramme=this.props.countProgramme!==undefined ? this.props.countProgramme(this.props.property) : 0;
    var countProduct=this.props.countProduct!==undefined ? this.props.countProduct(this.props.property) : 0;
    var count = this.props.count!==undefined ||
                this.props.countProgramme!==undefined ||
                this.props.countProduct!==undefined ? countProduct + countProject + countProgramme : undefined;

    return this.state.editAccessControl ? (

        <AccessControl
          {...this.props}
          onCancel={this.editAccessControl.bind(this)}
          onChange={this.setAccessControl.bind(this)}
        />

    ) : (
      <div style={{display: "table-row", borderBottom:"solid 1px #C1C1C1"}}>
          <div style={{display:"table-cell", textAlign: "left",padding:5}}>
              {this.state.edit ? (
                <form method="POST" action={"/"+this.props.propertyName.toLowerCase()+"/"+property.id+"/"}>
                  Name:<br/>
                  <input defaultValue={property.name} name="name"/>
                  {this.props.propertyName.toLowerCase()==='portfolio' ? (
                    <div style={{paddingTop:10,paddingBottom:10}}>
                      Description<br/>
                      <textarea name="description" rows="5" cols = "60" defaultValue={property.description}/>
                    </div>
                  ) : null}
                  <input onClick={this.editProperty.bind(this)} type="button" value="Cancel"/> <input type="submit" value="Update"/>
                </form>
              ) : property.name}

              {count!==undefined && !this.state.edit ? (
                <span> ({count})</span>
              ) : null}
          </div>
          <div style={{display:"table-cell", textAlign: "left",padding:5}}>
              {this.props.editEnabled && !this.state.edit ? (
                <a href="#" onClick={this.editProperty.bind(this)}><img src="/icons/pen_grey_tran.png"/></a>
              ) : null}
          </div>
          <div style={{display:"table-cell", textAlign: "left",padding:5, paddingRight:15}}>
              {this.props.deleteEnabled && !this.state.edit && count===0  ? (
                <a style={{paddingLeft: 20}} href={"/"+this.props.propertyName.toLowerCase()+"/"+property.id+"/delete"}><img src="/icons/delete_grey.png"/> </a>
              ) : null}
          </div>
          <div style={{display:"table-cell", textAlign: "left",padding:5}}>
              {this.props.accessControllEnabled && !this.state.edit ? (
                <span>
                  {this.props.property.accessControl!==undefined ? (
                    <span>
                      <span style={{color: "red"}}>limited access</span>
                      <span> (</span>
                      {this.props.property.accessControl.join(", ")}
                      <span>) </span>
                      <a href="#" onClick={this.editAccessControl.bind(this)}>Edit access control</a>
                    </span>
                  ) : (
                    <a href="#" onClick={this.editAccessControl.bind(this)}>Enable access control</a>
                  )}
                </span>
              ) : null}
         </div>
        </div>
    );
  }
}

class ListProperty extends React.Component {
  render() {
    var propertyName=this.props.propertyName;
    var pluralName=propertyName.slice(-1)==="y" ? propertyName.slice(0,-1)+"ies" : propertyName+"s";
    return (
      <div>
        <h3>{pluralName}</h3>
        <div style={{maxWidth:610}}>
          {this.props.description} <br/><br/>
        </div>
        {this.props.property!==undefined && this.props.property.length>0 ? (
          <div style={{display:"table", minWidth:610, marginBottom:20, marginRight:20, marginTop:10, float: "left",  borderCollapse:"collapse"}}>

            {this.props.property.map(property=><ShowProperty key={property.id} {...this.props} property={property}/>)}
          </div>

        ) : (
          <i>No {pluralName.toLowerCase()} defined yet.</i>
        )}
      </div>
    )
  }
}

class PropertyManagement extends React.Component {
  constructor(props) {
    super(props);
    this.state={details:false};
  }

  render() {
    if (this.props.user!==undefined && this.props.tenant.owner.id===this.props.user.id) {
      return (
        <div style={{display:"flex", justifyContent:"flex-start", marginTop:20, flexWrap:"wrap"}}>
          <ListProperty {...this.props}/>
          <form method="POST" action={"/"+this.props.propertyName.toLowerCase()}>
          <div >
            <div style={{marginBottom:20}}>
              <input name="name" className="input" placeholder={this.props.propertyName+" name"} autoComplete="off" size="73"/>
            </div>
            <div>
              <input type="submit" className="save" value={"Add "+this.props.propertyName.toLowerCase()}/>
            </div>
           </div>
          </form>

        </div>
      )
    } else {
      return (this.props.property!==undefined && this.props.propertylength>0) ? (
        <ListProperty {...this.props}/>
      ) : null;
    }
  }
}

class DesignConfiguration extends React.Component {
  constructor(props) {
    super(props);
  }


  render() {
    if (this.props.user!==undefined && this.props.tenant.owner.id===this.props.user.id) {
      var layout=this.props.tenant.design!==undefined ? this.props.tenant.design : {};
      return  (
        <div>
          <form method="POST" action="/configureDesign">
            <input type="hidden" name="tenant" value={this.props.tenant.id}/>
            Logo: <input size="80" placeholder="(url)" name="logo" defaultValue={layout.logo}/><br/>
            Logo background color: <input size="80" placeholder="(color)" name="backgroundColor" defaultValue={layout.backgroundColor}/> (optional)<br/>
            Logo background: <input size="80" placeholder="(url)" name="background" defaultValue={layout.background}/> (optional)<br/>
            Logo position: <input size="20" placeholder="(eg 0px -400px)" name="position" defaultValue={layout.position}/> (optional)<br/>
            Logo size: <input size="10" placeholder="(eg 100px or contain)" name="size" defaultValue={layout.size}/> (default is contain)<br/>
            Color:  <input size="10" placeholder="Account color (eg #ab12ef)" name="color" defaultValue={layout.color}/><br/>
            Height: <input size="15" placeholder="Height" name="height" defaultValue={layout.height}/> (Header, default is 48)<br/>
            Width:  <input size="15" placeholder="Width" name="width" defaultValue={layout.width}/> (Logo area i header, default is 165)<br/>
            Show account name: <input type="checkbox" name="showTenantName" defaultChecked={layout.showTenantName}/> (displayed below header as default)<br/>
            Use custom header: <input type="checkbox" name="enabled" defaultChecked={layout.enabled}/> <br/>
            Logo for report: <input size="80" placeholder="(url)" name="reportLogo" defaultValue={layout.reportLogo}/> (otional, use logo as default)<br/>
            Website Title: <input placeholder="Progreto - the project portfolio management tool" name="title" size="50" defaultValue={layout.title}/><br/>
            {this.props.tenant.sso!==undefined && this.props.tenant.sso.enabled ? (
              <div>
                Favicon: <input placeholder="Specify url to favicon.ico (https)" name="favicon" size="80" defaultValue={layout.favicon}/> (requests are redirected)
              </div>
            ) : null}
            {this.props.draftFeaturesEnabled ? (
              <div>
                Language:
                <select name="language" defaultValue={this.props.tenant.language}>
                  <option value="english">English</option>
                  <option value="norwegian">Norwegian</option>
                </select>
              </div>
            ) : null}
            <div style={{paddingTop:10}}>
              <input type="submit" className="save" value="Save"/>
            </div>
          </form>
        </div>
      ) ;

  }
}
}

class StandardLinkForm extends React.Component {
  addLink(event) {
    event.preventDefault();
    cosole.log("Add link");
    this.props.sendCommand({
      type:"addStandardLink",
      title: event.target.title.value,
      address: event.target.address.value,
      parameters: event.target.parameterName.value!==undefined && event.target.parameterName.value.trim().length>0 ?
        [{name:event.target.parameterName.value, key:event.target.parameterValue.value}] : []
    });
  }

  render() {
    return (
      <div style={{maxWidth:800}}>
        <h4>Standard link</h4>
        <form action="/links/standard/" method="POST">
          {this.props.id!==undefined ? (
              <input type="hidden" name="id" value={this.props.id}/>
            ) : null}
          <Area title="Link">
            <Field title="Title" name="title" value={this.props.title}/>
            <Field title="Address" name="address" value={this.props.address}/>
          </Area>
          <Area title="Parameter">
            <div style={{paddingBottom: 10}}>
              <i>Leave parameter name empty if no parameter is required.</i>
            </div>
            <Field title="Name" name="parameterName" value={this.props.parameters!==undefined && this.props.parameters.length>0 ? this.props.parameters[0].name : undefined}/>
            <Field title="Value" name="parameterValue" value={this.props.parameters!==undefined && this.props.parameters.length>0 ? this.props.parameters[0].key : undefined} options={[{text:"Project identifier", value:"identifier"}]}/>
          </Area>
          <div style={{paddingBottom:50}}>
            <input className="cancel" type="button" value="Cancel" onClick={this.props.onCancel}/>
            <input className="save" type="submit" className="save" value={this.props.id!==undefined ? "Update standard link" : "Add standard link"}/>
          </div>
        </form>
      </div>
    );
  }
}

class StandardLinkDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state={edit:false};
  }

  toggleEdit(event) {
    event.preventDefault();
    this.setState({edit:!this.state.edit});
  }

  deleteLink(event) {
    event.preventDefault();
    request
      .delete("/links/standard/"+this.props.id+"/")
      .end(function(err,result) {
        if (err===null) {
          window.location.reload();
        } else {
          console.log("Error deleting "+this.props.title+": "+JSON.stringify(result),err);
          alert("An error occured, please try again");
        }
      }.bind(this));
  }

  render() {
    return this.state.edit ? (
      <tr>
        <td colSpan="4">
          <StandardLinkForm {...this.props} onCancel={this.toggleEdit.bind(this)}/>
        </td>
      </tr>
    ) :(
      <div style={{display: "table-row", borderBottom:"solid 1px #C1C1C1"}}>

        <div style={{display:"table-cell", textAlign: "left",padding:5}}>{this.props.title}</div>
        <div style={{display:"table-cell", textAlign: "left",padding:5, maxWidth:600, wordWrap:"break-word"}}>{this.props.address}</div>
        <div style={{display:"table-cell", textAlign: "left",padding:5}}>
          {this.props.parameters!==undefined && this.props.parameters.length>0 ?
            this.props.parameters.map(parameter=>parameter.name+"=<"+parameter.key+">").join("&")
          : null}
        </div>
        <div style={{display:"table-cell", textAlign: "left",padding:5}}>
          <a href="#" onClick={this.toggleEdit.bind(this)}><img style={{verticalAlign:"bottom"}} src="/icons/pen_grey_tran.png"/></a>
        </div>
        <div style={{display:"table-cell", textAlign: "left",padding:5}}>
          <a href="#" onClick={this.deleteLink.bind(this)} style={{paddingLeft: 20}}>
            <img src="/icons/delete_grey.png"/>
          </a>
        </div>
      </div>
    );
  }
}

class StandardLinks extends React.Component {
  constructor(props) {
    super(props);
    this.state={form:false};
  }

  showForm(event) {
    event.preventDefault();
    this.setState({form:!this.state.form});
  }

  render() {
    if (this.props.user!==undefined && this.props.tenant.owner.id===this.props.user.id) {
      return (
        <div>
          <h3>Standard links</h3><br/>
          Standard links are links to external applications. A standard link will show for all projects.<br/>
          Standard links can use the project identifier as parameter. A target system can use this parameter to show the relevant information.<br/>
          {this.props.tenant.standardLinks!==undefined ? (

              <div style={{display:"table", minWidth:610, marginBottom:40, marginRight:20, marginTop:30, float: "left",  borderCollapse:"collapse"}}>

                <div style={{display: "table-row", borderBottom:"solid 1px #C1C1C1"}}>
                  <div style={{display:"table-cell", fontWeight:"bold", textAlign: "left",padding:5}}>Title</div>
                  <div style={{display:"table-cell", fontWeight:"bold", textAlign: "left",padding:5}}>Address</div>
                  <div style={{display:"table-cell", fontWeight:"bold", textAlign: "left",padding:5}}>Parameters</div>
                  <div style={{display:"table-cell", fontWeight:"bold", textAlign: "left",padding:5}}></div>
                  <div style={{display:"table-cell", fontWeight:"bold", textAlign: "left",padding:5}}></div>
                </div>

                {this.props.tenant.standardLinks.map(link=><StandardLinkDetails key={link.id} {...link}/>)}

            </div>
          ) : (
            <i><br/>No standard links are defined</i>
          )}
          <div style={{paddingTop:15, minWidth:610, float:"left", paddingBottom:15}}>
            {this.state.form ? (
              <StandardLinkForm onCancel={this.showForm.bind(this)}/>
            ) : (
              <a href="#" onClick={this.showForm.bind(this)}>Add standard link</a>
            )}
          </div>
        </div>
      );
    } else {
      return null;
    }
  }
}

class CurrencySettings extends React.Component {
  constructor(props) {
    super(props);
    this.state={
      currencies: props.settings!==undefined ? props.settings : []
    };
  }

  componentWillReceiveProps(props) {
    this.setState({currencies: props.settings!==undefined ? props.settings : []});
  }

  update(event) {
    event.preventDefault();
    if (this.props.onUpdate!==undefined) {
      let currency=event.target.elements.currency.value;
      this.props.onUpdate(currency);
    }
  }


  render() {
    return (
      <div>
        <h3>Currencies</h3>
        These are the currencies one can chose from when documenting budgets in plans. <br/>
        {this.state.currencies!==undefined && this.state.currencies.length>0? (
          <div style={{display:"table", minWidth:610, marginBottom:20, marginRight:20, marginTop:10, float: "left",  borderCollapse:"collapse"}}>
            {this.state.currencies.map(currency=>
              <div style={{display: "table-row", borderBottom:"solid 1px #C1C1C1"}}>
                  <div style={{display:"table-cell", textAlign: "left",padding:5}}>{currency} - {currencies.find(item=>item.id===currency).title}
                  </div>
              </div>)
            }
          </div>
        ) : (
          <i>Currency is not defined</i>
        )}

          <form onSubmit={this.update.bind(this)} style={{paddingTop:15,maxWidth:610}}>
            <select className="input" name="currency">
              {currencies.map(item=>(
                <option value={item.id}>{item.id} - {item.title}</option>
              ))}
            </select>
            <div style={{paddingTop:15, paddingBottom:50}}>
              <input className="save"  type="submit" value="Add currency"/>
            </div>
          </form>

      </div>
    );
  }
}

class ProjectSettings extends React.Component {
  constructor(props) {
    super(props);
    this.state={
      details:false,
      currencies: props.tenant!==undefined && props.tenant.currencies!==undefined
        ? props.tenant.currencies
        : []
    };
  }

  toggle(event) {
    event.preventDefault();
    this.setState({details:!this.state.details});
  }

  updateBusinessCase(newSettings) {
    request
      .post("/configureProject/businessCase")
      .send({use:newSettings.use})
      .then(()=>{
        window.location.reload();
      })
      .catch((error)=>{
        console.log("Error configure business case: ",error);
        alert("An error occured, please try again");
      })
  }



  render() {
    if (this.props.user!==undefined && this.props.tenant.owner.id===this.props.user.id) {
      return  (
        <div style={{paddingTop:35}}>
          <h3>Project Themes</h3>
          <BusinessCaseSettings {...this.props} settings={{enabled:this.props.tenant.settings===undefined || this.props.tenant.settings!==undefined && this.props.tenant.settings.disableBusinessCase!==true}} onUpdate={this.updateBusinessCase.bind(this)}/>
        </div>
      );
  }
}
}


class Users extends React.Component {

  render() {
    return (
      <div>
        <div style={{paddingTop:20, paddingBottom:20, fontWeight:"bold", textAlign:"left", color:"#212121", fontSize:20, textTransform:"capitalize"}}>
          Users of account:  {this.props.tenant.name}
        </div>
        <table>
          <tbody>
            <tr>
              <th style={{textAlign:"left"}}>Admin:</th>
              <td>{this.props.tenant.owner!==undefined ?<Person {...this.props.tenant.owner}/> : <span style={{color: "red"}}>&lt;not defined&gt;</span>}</td>
            </tr>
            {this.props.tenant.stakeholders!==undefined && this.props.tenant.stakeholders.length>0
              ? (
                <tr>
                  <th style={{textAlign:"left", verticalAlign:"top"}}>Users:</th>
                  <td style={{paddingTop:15}}>{this.props.tenant.stakeholders.map(stakeholder=><Person key={stakeholder.id} {...stakeholder}/>)} </td>
                </tr>
              ) : null
            }
          </tbody>
        </table>
      </div>
  );
}
}

class AccountInfo extends React.Component {

  render() {
    return (
      <div>
        <div style={{paddingTop:20, paddingBottom:20, fontWeight:"bold", textAlign:"left", color:"#212121", fontSize:20, textTransform:"capitalize"}}>
          Account:  {this.props.tenant.name}
        </div>
        <p>Thank you for using a registered account. With a registered account you have:
        </p>
        <ul>
          <li>Access to your projects from any browser. Just login with your email address.</li>
          <li>Possibility to share portfolios with other users. You grant someone access to your account by giving them a role in a project (theme 'Organization'){this.props.user===undefined ? <span> when you are logged in</span>:""}.</li>
        </ul>
        <table>
          <tbody>
            <tr>
              <th style={{textAlign:"left"}}>Account owner:</th>
              <td>{this.props.tenant.owner!==undefined ?<Person {...this.props.tenant.owner}/> : <span style={{color: "red"}}>&lt;not defined&gt;</span>}</td>
            </tr>
          </tbody>
        </table>
      </div>
  );
}
}


export class AccountCreated extends React.Component {

  constructor(props) {
    super(props);
    this.state={
      selectedTab: props.selectedtab!==undefined ? props.selectedtab : "Account",
      currencies: props.tenant!==undefined && props.tenant.currencies!==undefined
        ? props.tenant.currencies
        : []
    };
  }

  updateCurrency(newCurrency) {
    request
      .post("/")
      .send({type:"addCurrency", currency: newCurrency})
      .then(response=>{
        let currencies=JSON.parse(response.text).currencies;
        if (currencies!==undefined) {
          this.setState({currencies:currencies})
        } else {
          console.log("[ERROR] Not able to read currencies on updated settings, got "+JSON.stringify(settings));
          alert("An error occured, please try again");
        }
      })
      .catch(error=>{
        console.log("Error adding currency: ",error);
        alert("An error occured, please try again");
        window.location.reload();
      })
  }


  render() {
    var supportEmail="mailto:support@progreto.com?subject=Request from "
        +this.props.tenant.name+"&body=Hi!%0D%0A%0D%0AI%20have%20request%20regarding%20%0D%0A%0D%0A%0D%0ARegards,%0D%0A"
        +(this.props.user!==undefined ? this.props.user.name+"%20(ref:%20"+this.props.user.id+")" : this.props.tenant.owner.name+"%20(ref:%20owner%20"+this.props.tenant.owner.id+")") +"%0D%0A"
        +this.props.tenant.name+"%20(ref:%20"+this.props.tenant.id+")";

    var borderSelected="solid #0079BD 5px";
    var border="solid #47b857 5px";
    var color="black";
    var fontWeight="bold";
    var textDecoration="underline";
    var cursor="pointer";
    var textDecorationSelected ="none";


    return (
      <div style={{marginLeft:30, marginTop:20, marginBottom: 20, maxWidth:1200, fontFamily:"Lato, Arial, Helvetica Neue, Helvetica, sans-serif"}}>

        <div style={{display:"flex", justifyContent:"space-around", flexWrap:"wrap", fontSize:"14pt", cursor:cursor, textDecoration: textDecoration, fontWeight:fontWeight, fontFamily:"Lato, Arial", textAlign:"center",  color:color}}>
          {this.props.user!==undefined && this.props.tenant.owner.id===this.props.user.id ? (
            <div style={{display:"contents"}}>
              <div  onClick={() => this.setState({selectedTab:"Account"})} style={{ margin:3, minWidth:100,  padding: 5, borderBottom:  this.state.selectedTab==="Account" ? ( borderSelected) : (border) }}>
                Account
              </div>
              <div  onClick={() => this.setState({selectedTab:"Users"})} style={{ margin:3, minWidth:100,  padding: 5, borderBottom:  this.state.selectedTab==="Users" ? ( borderSelected) : (border) }}>
                Users
              </div>
              <div  onClick={() => this.setState({selectedTab:"Portfolios"})} style={{margin:3, minWidth:100,  padding: 5, borderBottom: this.state.selectedTab==="Portfolios" ? (borderSelected) : (border)}}>
                Portfolios
              </div>
              <div  onClick={() => this.setState({selectedTab:"Properties"})} style={{margin:3, minWidth:100,  padding: 5, borderBottom: this.state.selectedTab==="Properties" ? (borderSelected) : (border)}}>
                Properties
              </div>
              <div onClick={() => this.setState({selectedTab:"ProjectSettings"})} style={{margin:3, minWidth:100,  padding: 5, borderBottom: this.state.selectedTab==="ProjectSettings" ? (borderSelected) : (border)}}>
                Projects
              </div>
              <div onClick={() => this.setState({selectedTab:"Lifecycles"})} style={{margin:3, minWidth:100,  padding: 5, borderBottom: this.state.selectedTab==="Lifecycles" ? (borderSelected) : (border)}}>
                Lifecycles
              </div>

              <div onClick={() => this.setState({selectedTab:"Design"})} style={{margin:3, minWidth:100,  padding: 5, borderBottom: this.state.selectedTab==="Design" ? (borderSelected) : (border)}}>
                Design
              </div>
              <div onClick={() => this.setState({selectedTab:"SSO"})} style={{margin:3, minWidth:100,  padding: 5, borderBottom: this.state.selectedTab==="SSO" ? (borderSelected) : (border)}}>
                SSO
              </div>
            </div>
          ) : null }
        </div>

        <div style={{backgroundColor:"#f7f7f7", paddingLeft:20, paddingRight:20, paddingBottom:20, paddingTop:5, marginBottom:20, marginTop:20, display:"flex", maxWidth:1200, justifyContent: "space-between", flexWrap:"wrap" }}>
          {this.state.selectedTab==="Account" ? <AccountInfo {...this.props}/> : null}
          {this.state.selectedTab==="Users" ? <Users {...this.props}/> : null}
          {this.state.selectedTab==="Design" ? <DesignConfiguration {...this.props}/> : null}
          {this.state.selectedTab==="SSO" ? <SSOConfiguration {...this.props}/> : null}
          {this.state.selectedTab==="Portfolios" ? (
            <div>
            <PropertyManagement {...this.props}
              propertyName="Portfolio"
              description="Portfolio is a collection of activities you want to manage with respect to funding, prioritization and balance of investment. "
              property={this.props.tenant.portfolios}
              editEnabled={true}
              count={portfolio=>this.props.projects!==undefined ? this.props.projects.filter(project=>project.portfolio===portfolio.id).length : 0}
              countProgramme={portfolio=>this.props.tenant.programmes!==undefined ? this.props.tenant.programmes.filter(programme=>programme.portfolio===portfolio.id).length : 0}
              countProduct={portfolio=>this.props.tenant.products!==undefined ? this.props.tenant.products.filter(product=>product.portfolio===portfolio.id).length : 0}
              deleteEnabled={true}
              accessControllEnabled={true}
            />
            </div>) : null}


        {this.state.selectedTab==="Lifecycles" ?  <LifecycleManagement {...this.props}/> : null}

        {this.state.selectedTab==="Properties" ? (
          <div>
          <PropertyManagement {...this.props}
            propertyName="Location"
            description="Location is the physical or geographic location where an activity is managed from"
            property={this.props.tenant.locations}
            editEnabled={true}
            count={location=>this.props.projects!==undefined ? this.props.projects.filter(project=>project.location===location.id).length : 0}
            deleteEnabled={true}/>

            <PropertyManagement {...this.props}
              propertyName="Department"
              description="Department is the business unit, line organization or staff function owning an activity"
              property={this.props.tenant.departments}
              editEnabled={true}
              count={location=>this.props.projects!==undefined ? this.props.projects.filter(project=>project.department===location.id).length : 0}
              deleteEnabled={true}/>

          <CurrencySettings {...this.props} settings={this.state.currencies} onUpdate={this.updateCurrency.bind(this)}/>
          </div>) : null}

        {this.state.selectedTab==="ProjectSettings" ? (
          <div>

            <PropertyManagement {...this.props}
              propertyName="Type"
              description = "There can be different types of projects like product development, IT Systems, organizational development etc. The main reason for defining types is to connect a type with a Lifecycle."
              property={this.props.tenant.projectTypes}
              editEnabled={true}
              count={projectType=>this.props.projects!==undefined ? this.props.projects.filter(project=>project.projectType===projectType.id).length : 0}
              deleteEnabled={true}/>

            <PropertyManagement {...this.props}
              description= "Category is a project attribute without any specific definition. It is only useful as a filtering criteria"
              propertyName="Category" property={this.props.tenant.categories}
              property={this.props.tenant.categories}
              editEnabled={true}
              count={category=>this.props.projects!==undefined ? this.props.projects.filter(project=>project.category===category.id).length : 0}
              deleteEnabled={true}/>
            <ProjectSettings {...this.props}/>
            <StandardLinks {...this.props}/>
          </div>) : null}

        </div>

        <div style={{marginTop:60}}>
        {this.props.user!==undefined && this.props.user.confirmation!==undefined
          ? (
            <p>
              A confirmation email has been sendt to email address
              <b>'{this.props.user.confirmation.email}'</b>
              at {this.props.user.confirmation.sent}.
            </p>
          ) : (
            <p>
              Please contact support at <a href={supportEmail}>support@progreto.com</a> if you need assistance.
            </p>
          )
        }
        {this.props.user===undefined
          ? (
            <p>
              To get access to all functionality of your account,
              {this.props.tenant.owner!==undefined && this.props.tenant.owner.emailConfirmation!==undefined
                ? (
                  <span> please confirm your email address by </span>
                ): (
                  <span> please</span>
                )} <a href="/login">login</a>.
            </p>
          )  : null
        }
        {this.props.otherTenants!==undefined && this.props.otherTenants.length>0
          ? (
            <p>
              Other tenants you can access: {this.props.otherTenants.map(tenant=><a key={tenant.id} style={{paddingRight: 15}} href={"/tenants/"+tenant.id+"/"}>{tenant.name}</a>)}
            </p>
          )
          : null
        }
        <p>
          <a href="/">Go to {this.props.tenant.name} home page</a>
        </p>
        </div>
      </div>
    );
  }
}

export default class AccountCreatedPage extends React.Component {
  render() {
    return (
      <Layout {...this.props}>
        <AccountCreated {...this.props}/>
      </Layout>
    );
  }
}



// WEBPACK FOOTER //
// ./views/settings/AccountCreated.jsx